export const loginRequest = {
  scopes: [process.env.REACT_APP_ACTIVEDIRECTORY_CLIENT_ID+'/.default'], // Scopes di base, aggiungi altri scopes se necessario
};
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ACTIVEDIRECTORY_CLIENT_ID,
    authority: process.env.REACT_APP_ACTIVEDIRECTORY_AUTHORITY,
    redirectUri: process.env.REACT_APP_DOMAIN,
    knownAuthorities: ["login.microsoftonline.com"],
  },
  cache: {
    cacheLocation: "localStorage", // Memorizza i dati in localStorage o sessionStorage
    storeAuthStateInCookie: true,  // Migliora la compatibilità con Safari
  }, 
  };
  